/**
 * The persisted app-lock flag, readable from the page and the service worker without pulling in
 * the lock controller. Unknown (IndexedDB unavailable or failing) counts as locked, so a
 * notification falls back to generic text rather than showing content (security review R3).
 * No record means the app lock has never engaged on this device: unlocked.
 */
import { idb } from './idb.js'

export const APP_LOCK_KEY = 'app-lock/v1'

export async function readAppLocked(
  get: (key: string) => Promise<{ locked?: boolean } | undefined> = (k) => idb.get(k),
): Promise<boolean> {
  try {
    const rec = await get(APP_LOCK_KEY)
    return rec?.locked === true
  } catch {
    return true
  }
}
